import React from 'react';
import isBlank from '../utilities/isBlank';
import currencySym from 'currency-symbol-map';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const validateSendOfferForm = (values, props) => {
  const { message } = values;
  const { guestPayment, currency } = props;

  return {
    message: 999999.99 < guestPayment
      ? <FormattedMessage
        id='inbox.validate_send_offer_form.total_offer'
        defaultMessage='Your total offer must be under {price}. Please modify your offer.'
        values={{
          price: <FormattedNumber value={1000000} currency='USD' style='currency' />
        }}
      />
      : isBlank(message)
        ? <FormattedMessage id='inbox.validate_send_offer_form.enter_message' defaultMessage='Please enter a message' />
        : ''
  };
};

export default validateSendOfferForm;
